import * as regex from '../constants/Regex'

/**
 * validarRegexNumericoFloat = solo para flotantes positivas
 * @param valor valor tipo string
 * @returns String numerico
 */
export const validarRegexNumericoFloat = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_FLOAT.test(valor)
}

export const validarRegexNumericoFloat2Decimales = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_FLOAT_2DECIMALES.test(valor)
}

export const validaRegexNumericoFloatNDecimales = (valor: string): boolean => {
  if(!valor) return true
  return regex.REGEX_FLOAT_NDECIMALES.test(valor)
}

/**
 * validarRegexNumericoInt = solo para enteros positivas
 * @param valor valor tipo string
 * @returns String numerico
 */
export const validarRegexNumericoInt = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_FEX.test(valor)
}

export const validarRegexLetras = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_LETTERS.test(valor)
}

export const validarRegexLetrasEspaciosNums = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_LETRAS_ESPACIOS_NUMS.test(valor)
}

export const validarRegexNombresCliente = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_LETRAS_NOMBRES_CLIENTES.test(valor)
}

export const validarRegexUsername = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_USER_NAME.test(valor)
}

export const validarRegexSoloLetrasSpanish = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_SOLO_LETRAS_SPANISH.test(valor)
}

export const validarRegexSoloLetrasEspacio = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_LETRAS_ESPACIOS.test(valor)
}

export const validarRegexNumIdentificacion = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_USER_NUM_DOCUMENTO.test(valor)
}

export const validarRegexNumEnteroGuion = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_INT_GUION.test(valor)
}

export const validarRegexAlfaNum = (valor: string): boolean => {
  return regex.REGEX_ALFANUM.test(valor)
}

export const validarRegexProductoTexto = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_PRODUCTO_TEXTO.test(valor)
}

export const validarRegexCodigoProducto = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_CODIGO_PRODUCTO.test(valor)
}


export const validarRegexNumDocGuion = (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_DOC_GUION.test(valor)
}

// Verifica si es nulo o vacio
export const isNullOrEmpty = (value: any) => {
  if (value === null) return true
  if (value === undefined) return true
  if (typeof value === 'string') {
    if (value.trim() === 'null') return true
    if (value.trim().length === 0) return true
  }
  return false
}

export function formatDateToDDMMYYYY(dateString: string): string {
  if (dateString) {
    const dateParts = dateString.split('-')
    if (dateParts.length !== 3) {
      throw new Error('Fecha inválida')
    }
  
    const year = dateParts[0]
    const month = dateParts[1]
    const day = dateParts[2]
  
    return `${day}/${month}/${year}`
  } else {
    return ``;
  }
}

export const formatDateTime = (dateStr: string) => {
  if (dateStr) {
    try {
      const parts = dateStr.split('T');
      const dateParts = parts[0].split('-');
      const horaParts = parts[1].split(':');
  
      const year = dateParts[0]
      const month = dateParts[1]
      const day = dateParts[2]
  
      const hora = horaParts[0]
      const min = horaParts[1]
      const sec = horaParts[2]
      
      return `${day}/${month}/${year} ${hora}:${min}:${sec}`;
    } catch (e) {
      return `N/A`;
    }
  }
  return ``;
}

export function quitarAcentos(value: string): string {
  return (value) ? value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim() : '';
}

export const convertStringToNit = (nit: string): string => {
  let nit2 = nit
  if (nit.length >= 10 && !nit.includes('-')) {
    nit2 = `${nit.substring(0, 4)}-${nit.substring(4, 10)}-${nit.substring(10, nit.length)}`
  }
  return nit2
}

export const validarAlfanumConEspeciales = (valor: string): boolean => {
  return regex.REGEX_ALFANUM_CON_ESPECIALES.test(valor)
}

export const validarAlfanumericoEspacios = (valor: string): boolean => {
  return regex.REGEX_ALFANUM_ESPACIOS.test(valor)
}

export const validarAlfanumerico = (valor: string): boolean => {
  return regex.REGEX_ALFANUM.test(valor)
}

export const validarRegexPasaporte= (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_PASAPORTE.test(valor)
}
export const validarRegexDUI= (valor: string): boolean => {
  if (!valor) return true
  return !regex.REGEX_DUI.test(valor)
}
export const validarRegexCarnetResidencial= (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_CARNET_REDIDENCIAL.test(valor)
}
export const validarRegexNIT= (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_NIT.test(valor)
}
export const validarRegexOtro= (valor: string): boolean => {
  if (!valor) return true
  return regex.REGEX_OTRO.test(valor)
}


export const ReplaceRegexSinLetras= (valor: string): string => {
  return String(valor).replace(/[^0-9\s-]/g, "")
}

export const getId = () => Math.floor(Math.random() * 900000) + 100000

export const determinarAMoPM = (valorTiempo: string) => {
  // Dividir el valor del tiempo en sus componentes (horas y minutos)
  const [horas] = valorTiempo.split(':').map(Number);
  // Determinar si es "AM" o "PM"
  if (horas >= 0 && horas < 12) {
    return "am";
  } else {
    return "pm";
  }
}

export const obtenerHoraActualStr = (horaCompleta: string) => {
  const [hora, minutos] = horaCompleta.split(':').slice(0, 2);
  return `${hora}:${minutos}`;
}

export const unirChipsArray = (chips: Array<string>, valueSuelto: string) => {
  if (chips?.length <= 0) return [valueSuelto];
  if (!valueSuelto) return chips;
  return [...chips, valueSuelto];
}

export const unirChipsReturnFirst = (chips: Array<string>, valueSuelto: string) => {
  if (chips?.length <= 0) return valueSuelto;
  if (!valueSuelto) return chips[0];
  return [...chips, valueSuelto][0];
}

export const unirChipsJoin = (chips: Array<string>, valueSuelto: string) => {
  if (chips?.length <= 0) return valueSuelto;
  if (!valueSuelto) return chips.join(",");
  return [...chips, valueSuelto].join(",");
}

export const getEmailNotifyMsg = (emails: any) => {
  return `
    <p>
      El cliente presentó incidencias en el último envío de correo, por favor verificar los siguientes datos:
      <ul>
        ${emails?.map((email: any) => (
          `<li>${email?.Correo}</li>`
        ))}
      </ul>
    </p>
  `;
}